module.exports = __webpack_public_path__ + "static/media/20200415_083900.08222460.jpg";